// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/invoices.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { CardCheckResultEnum, DiscountTypeEnum, DisputeStatusEnum, EventTypeEnum, InvoiceStatusEnum, ItemKindEnum, ItemUnitEnum, ManualPaymentMethodEnum, PaymentIntentStatusEnum, PaymentNetworkStatusEnum, PaymentOutcomeTypeEnum, PaymentRiskLevelEnum, PaymentScheduleStatusEnum, PaymentStatusEnum, PortalAttributionModeEnum, QuotePaymentScheduleAmountTypeEnum, QuotePaymentScheduleDueDateAnchorEnum, QuoteRejectionReasonEnum, QuoteStatusEnum, StripeCheckoutPaymentMethodEnum, StripePaymentStatusEnum, TipAllocationModeEnum } from "./settings_pb";
import { file_cortado_v1_settings } from "./settings_pb";
import type { User } from "./users_pb";
import { file_cortado_v1_users } from "./users_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/invoices.proto.
 */
export const file_cortado_v1_invoices: GenFile = /*@__PURE__*/
  fileDesc("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", [file_cortado_v1_settings, file_cortado_v1_users, file_google_protobuf_timestamp]);

/**
 * QuoteEvent represents an event associated with a quote revision
 * Captures event dates/times for the quote, which determine booking events on acceptance
 * Fields are aligned with Event for seamless quote-to-booking conversion
 *
 * @generated from message cortado.v1.QuoteEvent
 */
export type QuoteEvent = Message<"cortado.v1.QuoteEvent"> & {
  /**
   * Unique identifier for the quote event
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID the quote event belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Quote revision ID this event belongs to
   *
   * @generated from field: string quote_revision_id = 3;
   */
  quoteRevisionId: string;

  /**
   * Date of the event (optional - may not be set initially)
   *
   * @generated from field: optional google.protobuf.Timestamp event_date = 4;
   */
  eventDate?: Timestamp;

  /**
   * Length of the event in hours (optional) - aligned with Event.event_length
   *
   * @generated from field: optional double event_length = 5;
   */
  eventLength?: number;

  /**
   * Number of guests (optional) - aligned with Event.event_guests
   *
   * @generated from field: optional int32 event_guests = 6;
   */
  eventGuests?: number;

  /**
   * Timezone of the event (optional) - aligned with Event.event_timezone
   *
   * @generated from field: optional string event_timezone = 7;
   */
  eventTimezone?: string;

  /**
   * Location of the event (optional) - aligned with Event.event_location
   *
   * @generated from field: optional string event_location = 8;
   */
  eventLocation?: string;

  /**
   * Number of baristas (optional) - aligned with Event.barista_count
   *
   * @generated from field: optional int32 barista_count = 9;
   */
  baristaCount?: number;

  /**
   * Number of carts (optional) - aligned with Event.cart_count
   *
   * @generated from field: optional int32 cart_count = 10;
   */
  cartCount?: number;

  /**
   * Inquiry (request) event this quote event was copied from, when known.
   * A soft reference: the inquiry event may since have been edited or removed.
   *
   * @generated from field: optional string source_inquiry_event_id = 11;
   */
  sourceInquiryEventId?: string;
};

/**
 * Describes the message cortado.v1.QuoteEvent.
 * Use `create(QuoteEventSchema)` to create a new message.
 */
export const QuoteEventSchema: GenMessage<QuoteEvent> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 0);

/**
 * Quote represents a quote with current revision data denormalized
 *
 * @generated from message cortado.v1.Quote
 */
export type Quote = Message<"cortado.v1.Quote"> & {
  /**
   * Core identification
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string inquiry_id = 3;
   */
  inquiryId: string;

  /**
   * @generated from field: string contact_id = 4;
   */
  contactId: string;

  /**
   * @generated from field: int32 quote_number = 5;
   */
  quoteNumber: number;

  /**
   * Revision tracking
   *
   * @generated from field: string current_revision_id = 6;
   */
  currentRevisionId: string;

  /**
   * @generated from field: optional string accepted_revision_id = 7;
   */
  acceptedRevisionId?: string;

  /**
   * Current revision data (denormalized from current_revision)
   *
   * @generated from field: string title = 10;
   */
  title: string;

  /**
   * @generated from field: optional string description = 11;
   */
  description?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp valid_until = 12;
   */
  validUntil?: Timestamp;

  /**
   * @generated from field: int64 subtotal_cents = 13;
   */
  subtotalCents: bigint;

  /**
   * Now calculated as SUM of line item taxes
   *
   * @generated from field: int64 sales_tax_cents = 15;
   */
  salesTaxCents: bigint;

  /**
   * @generated from field: optional cortado.v1.DiscountTypeEnum discount_type = 16;
   */
  discountType?: DiscountTypeEnum;

  /**
   * @generated from field: optional double discount_value = 17;
   */
  discountValue?: number;

  /**
   * @generated from field: int64 discount_cents = 18;
   */
  discountCents: bigint;

  /**
   * @generated from field: optional int64 enforced_tip_cents = 19;
   */
  enforcedTipCents?: bigint;

  /**
   * @generated from field: optional bool enforced_tip_enabled = 26;
   */
  enforcedTipEnabled?: boolean;

  /**
   * @generated from field: optional double enforced_tip_percentage = 27;
   */
  enforcedTipPercentage?: number;

  /**
   * Excludes tip
   *
   * @generated from field: int64 total_cents = 20;
   */
  totalCents: bigint;

  /**
   * total_cents plus enforced_tip_cents: the amount the customer pays at checkout.
   *
   * @generated from field: int64 total_with_tip_cents = 87;
   */
  totalWithTipCents: bigint;

  /**
   * @generated from field: repeated cortado.v1.QuoteLineItem line_items = 21;
   */
  lineItems: QuoteLineItem[];

  /**
   * Discount denormalization (added for reporting/grouping)
   *
   * @generated from field: optional string discount_id = 24;
   */
  discountId?: string;

  /**
   * @generated from field: optional string discount_name = 25;
   */
  discountName?: string;

  /**
   * Status and tracking
   *
   * @generated from field: cortado.v1.QuoteStatusEnum status = 30;
   */
  status: QuoteStatusEnum;

  /**
   * @generated from field: optional google.protobuf.Timestamp sent_at = 31;
   */
  sentAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp viewed_at = 32;
   */
  viewedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp accepted_at = 33;
   */
  acceptedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp rejected_at = 84;
   */
  rejectedAt?: Timestamp;

  /**
   * @generated from field: cortado.v1.QuoteRejectionReasonEnum rejection_reason_category = 85;
   */
  rejectionReasonCategory: QuoteRejectionReasonEnum;

  /**
   * @generated from field: optional string rejection_reason = 86;
   */
  rejectionReason?: string;

  /**
   * Event details (denormalized from current revision) - LEGACY single event fields
   * Use quote_events for multi-event support; these are kept for backward compatibility
   *
   * @generated from field: optional google.protobuf.Timestamp event_date = 34;
   */
  eventDate?: Timestamp;

  /**
   * @generated from field: optional string event_location = 35;
   */
  eventLocation?: string;

  /**
   * @generated from field: optional int32 guest_count = 36;
   */
  guestCount?: number;

  /**
   * in hours
   *
   * @generated from field: optional double event_duration = 37;
   */
  eventDuration?: number;

  /**
   * Audit fields
   *
   * @generated from field: google.protobuf.Timestamp created_at = 40;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 41;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 42;
   */
  updatedBy: string;

  /**
   * Payment schedules (denormalized from current revision)
   *
   * @generated from field: repeated cortado.v1.QuotePaymentSchedule payment_schedules = 50;
   */
  paymentSchedules: QuotePaymentSchedule[];

  /**
   * Embedded objects (optional enrichment)
   *
   * @generated from field: optional cortado.v1.User updated_by_user = 51;
   */
  updatedByUser?: User;

  /**
   * Quote events (multiple events per quote revision)
   * These determine the booking events when the quote is accepted
   *
   * @generated from field: repeated cortado.v1.QuoteEvent quote_events = 71;
   */
  quoteEvents: QuoteEvent[];

  /**
   * Payment method override for checkout (empty = use org defaults)
   *
   * @generated from field: repeated cortado.v1.StripeCheckoutPaymentMethodEnum checkout_payment_methods = 80;
   */
  checkoutPaymentMethods: StripeCheckoutPaymentMethodEnum[];

  /**
   * Add-on offers available to the customer on this quote revision
   *
   * @generated from field: repeated cortado.v1.QuoteAddonOffer addon_offers = 81;
   */
  addonOffers: QuoteAddonOffer[];

  /**
   * Whether accepting this quote attaches a questionnaire to the booking.
   * Copied from the lead at quote creation and overridable per quote.
   * Metadata only - changing it does NOT create a new revision.
   *
   * @generated from field: bool requires_questionnaire = 82;
   */
  requiresQuestionnaire: boolean;

  /**
   * @generated from field: optional string job_id = 83;
   */
  jobId?: string;

  /**
   * How the enforced tip is spread across payment schedules
   *
   * @generated from field: cortado.v1.TipAllocationModeEnum tip_allocation_mode = 88;
   */
  tipAllocationMode: TipAllocationModeEnum;
};

/**
 * Describes the message cortado.v1.Quote.
 * Use `create(QuoteSchema)` to create a new message.
 */
export const QuoteSchema: GenMessage<Quote> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 1);

/**
 * QuoteAddonOffer represents an optional catalog item offered to the
 * customer on a quote revision. Offers are snapshotted per-revision; the
 * customer's selections become QuoteLineItems with source_addon_offer_id set.
 *
 * @generated from message cortado.v1.QuoteAddonOffer
 */
export type QuoteAddonOffer = Message<"cortado.v1.QuoteAddonOffer"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string quote_revision_id = 2;
   */
  quoteRevisionId: string;

  /**
   * @generated from field: optional string source_item_id = 3;
   */
  sourceItemId?: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: optional string description = 5;
   */
  description?: string;

  /**
   * @generated from field: int64 unit_price_cents = 6;
   */
  unitPriceCents: bigint;

  /**
   * @generated from field: string unit = 8;
   */
  unit: string;

  /**
   * @generated from field: int32 sort_order = 10;
   */
  sortOrder: number;

  /**
   * Per-offer tax fields
   *
   * @generated from field: bool is_taxable = 11;
   */
  isTaxable: boolean;

  /**
   * @generated from field: optional string sales_tax_rate_id = 12;
   */
  salesTaxRateId?: string;

  /**
   * @generated from field: optional string sales_tax_rate_name = 13;
   */
  salesTaxRateName?: string;

  /**
   * @generated from field: optional double sales_tax_rate = 14;
   */
  salesTaxRate?: number;

  /**
   * Quantity authored by the tenant in the quote builder. The customer can
   * only opt the add-on in or out; they cannot change this quantity.
   *
   * @generated from field: double quantity = 15;
   */
  quantity: number;

  /**
   * Server-computed total (unit_price_cents x quantity, rounded the same way
   * as the resulting line item). Never trust a client-side recomputation of
   * this value.
   *
   * @generated from field: int64 total_cents = 16;
   */
  totalCents: bigint;

  /**
   * Images of the source catalog item, cover first. Set on the customer portal
   * mount, like QuoteLineItem.images.
   *
   * @generated from field: repeated cortado.v1.LineItemImage images = 22;
   */
  images: LineItemImage[];

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.QuoteAddonOffer.
 * Use `create(QuoteAddonOfferSchema)` to create a new message.
 */
export const QuoteAddonOfferSchema: GenMessage<QuoteAddonOffer> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 2);

/**
 * QuoteAddonOfferInput represents input data for creating a quote add-on offer
 * Supports two modes:
 * 1. Catalog item: Provide item_id, backend fetches item details
 * 2. Custom offer: Provide name, unit, unit_price_cents directly
 *
 * @generated from message cortado.v1.QuoteAddonOfferInput
 */
export type QuoteAddonOfferInput = Message<"cortado.v1.QuoteAddonOfferInput"> & {
  /**
   * Optional - present when editing an existing offer
   *
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * Optional - for catalog-seeded offers
   *
   * @generated from field: optional string item_id = 2;
   */
  itemId?: string;

  /**
   * Optional - required for custom offers
   *
   * @generated from field: optional string name = 3;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 4;
   */
  description?: string;

  /**
   * Optional - overrides catalog item price OR required for custom offers
   *
   * @generated from field: optional int64 unit_price_cents = 5;
   */
  unitPriceCents?: bigint;

  /**
   * Optional - required for custom offers (default: "Per Event")
   *
   * @generated from field: optional string unit = 6;
   */
  unit?: string;

  /**
   * @generated from field: optional int32 sort_order = 7;
   */
  sortOrder?: number;

  /**
   * Per-offer tax fields
   *
   * @generated from field: bool is_taxable = 8;
   */
  isTaxable: boolean;

  /**
   * @generated from field: optional string sales_tax_rate_id = 9;
   */
  salesTaxRateId?: string;

  /**
   * @generated from field: optional string sales_tax_rate_name = 10;
   */
  salesTaxRateName?: string;

  /**
   * @generated from field: optional double sales_tax_rate = 11;
   */
  salesTaxRate?: number;

  /**
   * Optional - defaults to 1 when omitted
   *
   * @generated from field: optional double quantity = 12;
   */
  quantity?: number;
};

/**
 * Describes the message cortado.v1.QuoteAddonOfferInput.
 * Use `create(QuoteAddonOfferInputSchema)` to create a new message.
 */
export const QuoteAddonOfferInputSchema: GenMessage<QuoteAddonOfferInput> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 3);

/**
 * QuoteLineItemInput represents input data for creating a quote line item
 * Supports two modes:
 * 1. Catalog item: Provide item_id, backend fetches item details
 * 2. Custom item: Provide name, unit, unit_price_cents directly (one-time use)
 *
 * @generated from message cortado.v1.QuoteLineItemInput
 */
export type QuoteLineItemInput = Message<"cortado.v1.QuoteLineItemInput"> & {
  /**
   * Optional - for catalog items
   *
   * @generated from field: optional string item_id = 1;
   */
  itemId?: string;

  /**
   * Required - quantity of item (supports fractional quantities like 2.5 hours)
   *
   * @generated from field: double quantity = 2;
   */
  quantity: number;

  /**
   * Optional - overrides catalog item price OR required for custom items
   *
   * @generated from field: optional int64 unit_price_cents = 3;
   */
  unitPriceCents?: bigint;

  /**
   * Optional - required for custom items (one-time use)
   *
   * @generated from field: optional string name = 4;
   */
  name?: string;

  /**
   * Optional - for custom items
   *
   * @generated from field: optional string description = 5;
   */
  description?: string;

  /**
   * Optional - required for custom items (default: "Per Event")
   *
   * @generated from field: optional string unit = 6;
   */
  unit?: string;

  /**
   * Per-line-item tax fields
   *
   * Required - whether this line item is taxable (default: true)
   *
   * @generated from field: bool is_taxable = 7;
   */
  isTaxable: boolean;

  /**
   * Optional - UUID reference to tax_rates table
   *
   * @generated from field: optional string sales_tax_rate_id = 8;
   */
  salesTaxRateId?: string;

  /**
   * Optional - denormalized tax rate name
   *
   * @generated from field: optional string sales_tax_rate_name = 9;
   */
  salesTaxRateName?: string;

  /**
   * Optional - tax rate as decimal (e.g., 0.0825 for 8.25%)
   *
   * @generated from field: optional double sales_tax_rate = 10;
   */
  salesTaxRate?: number;

  /**
   * Required - pre-calculated tax amount in cents
   *
   * @generated from field: int64 sales_tax_cents = 11;
   */
  salesTaxCents: bigint;

  /**
   * @generated from field: optional string quote_revision_event_id = 12;
   */
  quoteRevisionEventId?: string;
};

/**
 * Describes the message cortado.v1.QuoteLineItemInput.
 * Use `create(QuoteLineItemInputSchema)` to create a new message.
 */
export const QuoteLineItemInputSchema: GenMessage<QuoteLineItemInput> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 4);

/**
 * QuoteLite is a lightweight quote representation for list views
 *
 * @generated from message cortado.v1.QuoteLite
 */
export type QuoteLite = Message<"cortado.v1.QuoteLite"> & {
  /**
   * Core identification
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string inquiry_id = 3;
   */
  inquiryId: string;

  /**
   * @generated from field: string contact_id = 4;
   */
  contactId: string;

  /**
   * @generated from field: int32 quote_number = 5;
   */
  quoteNumber: number;

  /**
   * Summary fields
   *
   * @generated from field: optional string title = 10;
   */
  title?: string;

  /**
   * @generated from field: optional string contact_name = 11;
   */
  contactName?: string;

  /**
   * Excludes tip
   *
   * @generated from field: int64 total_cents = 12;
   */
  totalCents: bigint;

  /**
   * total_cents plus the revision's enforced tip.
   *
   * @generated from field: int64 total_with_tip_cents = 26;
   */
  totalWithTipCents: bigint;

  /**
   * @generated from field: cortado.v1.QuoteStatusEnum status = 13;
   */
  status: QuoteStatusEnum;

  /**
   * Timestamps
   *
   * @generated from field: optional google.protobuf.Timestamp sent_at = 20;
   */
  sentAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp valid_until = 21;
   */
  validUntil?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 22;
   */
  createdAt?: Timestamp;

  /**
   * Event dates across the quote's quote_events rows, ordered ascending (earliest first).
   * Clients can treat index 0 as the primary display date and the remainder as "+N more".
   *
   * @generated from field: repeated google.protobuf.Timestamp event_dates = 23;
   */
  eventDates: Timestamp[];

  /**
   * Whether accepting this quote attaches a questionnaire to the booking.
   *
   * @generated from field: bool requires_questionnaire = 24;
   */
  requiresQuestionnaire: boolean;

  /**
   * @generated from field: optional string job_id = 25;
   */
  jobId?: string;
};

/**
 * Describes the message cortado.v1.QuoteLite.
 * Use `create(QuoteLiteSchema)` to create a new message.
 */
export const QuoteLiteSchema: GenMessage<QuoteLite> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 5);

/**
 * ContactQuoteInteraction represents public quote token activity attributed to a contact
 *
 * @generated from message cortado.v1.ContactQuoteInteraction
 */
export type ContactQuoteInteraction = Message<"cortado.v1.ContactQuoteInteraction"> & {
  /**
   * Core identification
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string quote_id = 3;
   */
  quoteId: string;

  /**
   * @generated from field: optional string inquiry_id = 4;
   */
  inquiryId?: string;

  /**
   * @generated from field: optional string booking_id = 5;
   */
  bookingId?: string;

  /**
   * Recipient attribution
   *
   * @generated from field: optional string recipient_contact_id = 10;
   */
  recipientContactId?: string;

  /**
   * @generated from field: string recipient_email = 20;
   */
  recipientEmail: string;

  /**
   * Quote display fields
   *
   * @generated from field: int32 quote_number = 30;
   */
  quoteNumber: number;

  /**
   * @generated from field: optional string quote_title = 31;
   */
  quoteTitle?: string;

  /**
   * @generated from field: cortado.v1.QuoteStatusEnum quote_status = 32;
   */
  quoteStatus: QuoteStatusEnum;

  /**
   * Public interaction state
   *
   * @generated from field: int32 view_count = 40;
   */
  viewCount: number;

  /**
   * @generated from field: optional google.protobuf.Timestamp first_viewed_at = 41;
   */
  firstViewedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_viewed_at = 42;
   */
  lastViewedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp accepted_at = 43;
   */
  acceptedAt?: Timestamp;

  /**
   * Audit fields
   *
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 62;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.ContactQuoteInteraction.
 * Use `create(ContactQuoteInteractionSchema)` to create a new message.
 */
export const ContactQuoteInteractionSchema: GenMessage<ContactQuoteInteraction> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 6);

/**
 * QuoteLineItem represents a line item in a quote (from current revision)
 *
 * @generated from message cortado.v1.QuoteLineItem
 */
export type QuoteLineItem = Message<"cortado.v1.QuoteLineItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string quote_revision_id = 2;
   */
  quoteRevisionId: string;

  /**
   * @generated from field: optional string source_item_id = 3;
   */
  sourceItemId?: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: optional string description = 5;
   */
  description?: string;

  /**
   * @generated from field: int64 unit_price_cents = 6;
   */
  unitPriceCents: bigint;

  /**
   * @generated from field: double quantity = 7;
   */
  quantity: number;

  /**
   * @generated from field: string unit = 8;
   */
  unit: string;

  /**
   * @generated from field: int64 line_total_cents = 9;
   */
  lineTotalCents: bigint;

  /**
   * @generated from field: int32 sort_order = 10;
   */
  sortOrder: number;

  /**
   * Per-line-item tax fields
   *
   * @generated from field: bool is_taxable = 11;
   */
  isTaxable: boolean;

  /**
   * @generated from field: optional string sales_tax_rate_id = 12;
   */
  salesTaxRateId?: string;

  /**
   * @generated from field: optional string sales_tax_rate_name = 13;
   */
  salesTaxRateName?: string;

  /**
   * @generated from field: optional double sales_tax_rate = 14;
   */
  salesTaxRate?: number;

  /**
   * @generated from field: int64 sales_tax_cents = 15;
   */
  salesTaxCents: bigint;

  /**
   * Presence indicates this line item was added by the customer from a
   * QuoteAddonOffer (rather than authored on the quote by the tenant).
   *
   * @generated from field: optional string source_addon_offer_id = 21;
   */
  sourceAddonOfferId?: string;

  /**
   * Optional enrichment
   *
   * @generated from field: optional cortado.v1.Item source_item = 20;
   */
  sourceItem?: Item;

  /**
   * Images of the source catalog item, cover first. Set on the customer portal
   * mount, where source_item is not sent.
   *
   * @generated from field: repeated cortado.v1.LineItemImage images = 22;
   */
  images: LineItemImage[];
};

/**
 * Describes the message cortado.v1.QuoteLineItem.
 * Use `create(QuoteLineItemSchema)` to create a new message.
 */
export const QuoteLineItemSchema: GenMessage<QuoteLineItem> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 7);

/**
 * Invoice represents an invoice with current revision data and payment schedules
 * Supports two modes:
 * 1. Quote-based invoice: quote_id and accepted_quote_revision_id are provided (invoice copies from accepted quote)
 * 2. Standalone invoice: quote_id and accepted_quote_revision_id are null (invoice created directly)
 *
 * @generated from message cortado.v1.Invoice
 */
export type Invoice = Message<"cortado.v1.Invoice"> & {
  /**
   * Core identification
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string booking_id = 3;
   */
  bookingId: string;

  /**
   * Optional - null for standalone invoices
   *
   * @generated from field: optional string quote_id = 4;
   */
  quoteId?: string;

  /**
   * Optional - null for standalone invoices
   *
   * @generated from field: optional string accepted_quote_revision_id = 5;
   */
  acceptedQuoteRevisionId?: string;

  /**
   * @generated from field: string contact_id = 6;
   */
  contactId: string;

  /**
   * @generated from field: int32 invoice_number = 7;
   */
  invoiceNumber: number;

  /**
   * Revision tracking
   *
   * @generated from field: string current_revision_id = 10;
   */
  currentRevisionId: string;

  /**
   * @generated from field: optional string locked_revision_id = 11;
   */
  lockedRevisionId?: string;

  /**
   * Current revision data (denormalized from current_revision)
   *
   * @generated from field: string title = 20;
   */
  title: string;

  /**
   * @generated from field: optional string description = 21;
   */
  description?: string;

  /**
   * @generated from field: int64 subtotal_cents = 22;
   */
  subtotalCents: bigint;

  /**
   * Now calculated as SUM of line item taxes
   *
   * @generated from field: int64 sales_tax_cents = 23;
   */
  salesTaxCents: bigint;

  /**
   * Discount fields (denormalized)
   *
   * Type of discount (PERCENTAGE or FIXED_AMOUNT)
   *
   * @generated from field: optional cortado.v1.DiscountTypeEnum discount_type = 16;
   */
  discountType?: DiscountTypeEnum;

  /**
   * Numeric value of the discount
   *
   * @generated from field: optional double discount_value = 17;
   */
  discountValue?: number;

  /**
   * Calculated discount amount in cents
   *
   * @generated from field: int64 discount_cents = 24;
   */
  discountCents: bigint;

  /**
   * UUID reference for reporting
   *
   * @generated from field: optional string discount_id = 36;
   */
  discountId?: string;

  /**
   * Denormalized discount name
   *
   * @generated from field: optional string discount_name = 37;
   */
  discountName?: string;

  /**
   * Tip fields
   *
   * Calculated enforced tip amount in cents
   *
   * @generated from field: optional int64 enforced_tip_cents = 19;
   */
  enforcedTipCents?: bigint;

  /**
   * Total tip amount (enforced + custom)
   *
   * @generated from field: int64 tip_cents = 25;
   */
  tipCents: bigint;

  /**
   * Whether enforced tips are active
   *
   * @generated from field: optional bool enforced_tip_enabled = 38;
   */
  enforcedTipEnabled?: boolean;

  /**
   * Percentage for enforced tips
   *
   * @generated from field: optional double enforced_tip_percentage = 39;
   */
  enforcedTipPercentage?: number;

  /**
   * @generated from field: int64 total_cents = 26;
   */
  totalCents: bigint;

  /**
   * @generated from field: repeated cortado.v1.InvoiceLineItem line_items = 27;
   */
  lineItems: InvoiceLineItem[];

  /**
   * Payment schedules (nested)
   *
   * @generated from field: repeated cortado.v1.PaymentSchedule payment_schedules = 30;
   */
  paymentSchedules: PaymentSchedule[];

  /**
   * Financial summary (calculated)
   *
   * @generated from field: int64 amount_paid_cents = 40;
   */
  amountPaidCents: bigint;

  /**
   * @generated from field: int64 amount_due_cents = 41;
   */
  amountDueCents: bigint;

  /**
   * @generated from field: int64 tip_paid_cents = 42;
   */
  tipPaidCents: bigint;

  /**
   * @generated from field: int64 tip_due_cents = 43;
   */
  tipDueCents: bigint;

  /**
   * Status and locking
   *
   * @generated from field: cortado.v1.InvoiceStatusEnum status = 50;
   */
  status: InvoiceStatusEnum;

  /**
   * @generated from field: bool is_locked = 51;
   */
  isLocked: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp locked_at = 52;
   */
  lockedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp sent_at = 53;
   */
  sentAt?: Timestamp;

  /**
   * @generated from field: int32 tip_accounting_version = 54;
   */
  tipAccountingVersion: number;

  /**
   * Audit fields
   *
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 61;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 62;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 63;
   */
  updatedBy: string;

  /**
   * Embedded objects (optional enrichment)
   *
   * @generated from field: optional cortado.v1.User created_by_user = 70;
   */
  createdByUser?: User;

  /**
   * @generated from field: optional cortado.v1.User updated_by_user = 71;
   */
  updatedByUser?: User;

  /**
   * Refund tracking
   *
   * Total amount refunded across all refunds
   *
   * @generated from field: int64 total_refunded_cents = 80;
   */
  totalRefundedCents: bigint;

  /**
   * Amount refunded as goodwill (reduces effective total)
   *
   * @generated from field: int64 goodwill_refunded_cents = 81;
   */
  goodwillRefundedCents: bigint;

  /**
   * Payment method override for this invoice (empty = use org defaults)
   *
   * @generated from field: repeated cortado.v1.StripeCheckoutPaymentMethodEnum checkout_payment_methods = 90;
   */
  checkoutPaymentMethods: StripeCheckoutPaymentMethodEnum[];

  /**
   * @generated from field: optional string job_id = 91;
   */
  jobId?: string;

  /**
   * How the outstanding tip is spread across payment schedules
   *
   * @generated from field: cortado.v1.TipAllocationModeEnum tip_allocation_mode = 92;
   */
  tipAllocationMode: TipAllocationModeEnum;
};

/**
 * Describes the message cortado.v1.Invoice.
 * Use `create(InvoiceSchema)` to create a new message.
 */
export const InvoiceSchema: GenMessage<Invoice> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 8);

/**
 * InvoiceLite is a lightweight invoice representation for list views
 *
 * @generated from message cortado.v1.InvoiceLite
 */
export type InvoiceLite = Message<"cortado.v1.InvoiceLite"> & {
  /**
   * Core identification
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string booking_id = 3;
   */
  bookingId: string;

  /**
   * @generated from field: int32 invoice_number = 4;
   */
  invoiceNumber: number;

  /**
   * @generated from field: string contact_id = 5;
   */
  contactId: string;

  /**
   * @generated from field: optional string quote_id = 6;
   */
  quoteId?: string;

  /**
   * Summary fields
   *
   * @generated from field: optional string title = 10;
   */
  title?: string;

  /**
   * @generated from field: optional string contact_name = 11;
   */
  contactName?: string;

  /**
   * @generated from field: int64 total_cents = 12;
   */
  totalCents: bigint;

  /**
   * @generated from field: int64 amount_paid_cents = 13;
   */
  amountPaidCents: bigint;

  /**
   * @generated from field: int64 amount_due_cents = 14;
   */
  amountDueCents: bigint;

  /**
   * @generated from field: cortado.v1.InvoiceStatusEnum status = 15;
   */
  status: InvoiceStatusEnum;

  /**
   * @generated from field: bool is_locked = 16;
   */
  isLocked: boolean;

  /**
   * @generated from field: int64 tip_paid_cents = 42;
   */
  tipPaidCents: bigint;

  /**
   * @generated from field: int64 tip_due_cents = 43;
   */
  tipDueCents: bigint;

  /**
   * @generated from field: int32 tip_accounting_version = 54;
   */
  tipAccountingVersion: number;

  /**
   * Timestamps
   *
   * @generated from field: optional google.protobuf.Timestamp sent_at = 20;
   */
  sentAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 21;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional string job_id = 22;
   */
  jobId?: string;
};

/**
 * Describes the message cortado.v1.InvoiceLite.
 * Use `create(InvoiceLiteSchema)` to create a new message.
 */
export const InvoiceLiteSchema: GenMessage<InvoiceLite> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 9);

/**
 * InvoiceLineItem represents a line item in an invoice (from current revision)
 *
 * @generated from message cortado.v1.InvoiceLineItem
 */
export type InvoiceLineItem = Message<"cortado.v1.InvoiceLineItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string invoice_revision_id = 2;
   */
  invoiceRevisionId: string;

  /**
   * @generated from field: optional string source_quote_line_item_id = 3;
   */
  sourceQuoteLineItemId?: string;

  /**
   * @generated from field: optional string source_item_id = 4;
   */
  sourceItemId?: string;

  /**
   * @generated from field: string name = 5;
   */
  name: string;

  /**
   * @generated from field: optional string description = 6;
   */
  description?: string;

  /**
   * @generated from field: int64 unit_price_cents = 7;
   */
  unitPriceCents: bigint;

  /**
   * @generated from field: double quantity = 8;
   */
  quantity: number;

  /**
   * @generated from field: string unit = 9;
   */
  unit: string;

  /**
   * @generated from field: int64 line_total_cents = 10;
   */
  lineTotalCents: bigint;

  /**
   * @generated from field: int32 sort_order = 11;
   */
  sortOrder: number;

  /**
   * Per-line-item tax fields
   *
   * @generated from field: bool is_taxable = 12;
   */
  isTaxable: boolean;

  /**
   * @generated from field: optional string sales_tax_rate_id = 13;
   */
  salesTaxRateId?: string;

  /**
   * @generated from field: optional string sales_tax_rate_name = 14;
   */
  salesTaxRateName?: string;

  /**
   * @generated from field: optional double sales_tax_rate = 15;
   */
  salesTaxRate?: number;

  /**
   * @generated from field: int64 sales_tax_cents = 16;
   */
  salesTaxCents: bigint;

  /**
   * Optional enrichment
   *
   * @generated from field: optional cortado.v1.Item source_item = 20;
   */
  sourceItem?: Item;
};

/**
 * Describes the message cortado.v1.InvoiceLineItem.
 * Use `create(InvoiceLineItemSchema)` to create a new message.
 */
export const InvoiceLineItemSchema: GenMessage<InvoiceLineItem> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 10);

/**
 * ActiveCheckoutSession represents the currently open Stripe Checkout Session
 * for a payment schedule, when one exists.
 *
 * @generated from message cortado.v1.ActiveCheckoutSession
 */
export type ActiveCheckoutSession = Message<"cortado.v1.ActiveCheckoutSession"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents: bigint;

  /**
   * ISO 4217 code (e.g., "USD")
   *
   * @generated from field: string currency = 3;
   */
  currency: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 4;
   */
  expiresAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: int64 base_amount_cents = 6;
   */
  baseAmountCents: bigint;

  /**
   * @generated from field: int64 tip_amount_cents = 7;
   */
  tipAmountCents: bigint;
};

/**
 * Describes the message cortado.v1.ActiveCheckoutSession.
 * Use `create(ActiveCheckoutSessionSchema)` to create a new message.
 */
export const ActiveCheckoutSessionSchema: GenMessage<ActiveCheckoutSession> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 11);

/**
 * PaymentSchedule represents a scheduled payment for an invoice
 *
 * @generated from message cortado.v1.PaymentSchedule
 */
export type PaymentSchedule = Message<"cortado.v1.PaymentSchedule"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string invoice_id = 3;
   */
  invoiceId: string;

  /**
   * @generated from field: string invoice_revision_id = 4;
   */
  invoiceRevisionId: string;

  /**
   * @generated from field: int32 sequence_number = 5;
   */
  sequenceNumber: number;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 7;
   */
  dueDate?: Timestamp;

  /**
   * @generated from field: int64 amount_cents = 8;
   */
  amountCents: bigint;

  /**
   * @generated from field: int64 amount_paid_cents = 9;
   */
  amountPaidCents: bigint;

  /**
   * @generated from field: cortado.v1.PaymentScheduleStatusEnum status = 10;
   */
  status: PaymentScheduleStatusEnum;

  /**
   * ISO 4217 code (e.g., "USD")
   *
   * @generated from field: string currency = 11;
   */
  currency: string;

  /**
   * Latest/current payment intent for this schedule
   *
   * @generated from field: optional cortado.v1.PaymentIntent current_payment_intent = 20;
   */
  currentPaymentIntent?: PaymentIntent;

  /**
   * @generated from field: optional cortado.v1.ActiveCheckoutSession active_checkout_session = 21;
   */
  activeCheckoutSession?: ActiveCheckoutSession;

  /**
   * Timestamps
   *
   * @generated from field: google.protobuf.Timestamp created_at = 30;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 31;
   */
  updatedAt?: Timestamp;

  /**
   * Refund tracking
   *
   * Goodwill refunds applied to this schedule
   *
   * @generated from field: int64 goodwill_refunded_cents = 40;
   */
  goodwillRefundedCents: bigint;

  /**
   * @generated from field: int64 expected_tip_cents = 41;
   */
  expectedTipCents: bigint;

  /**
   * @generated from field: int64 tip_paid_cents = 42;
   */
  tipPaidCents: bigint;

  /**
   * @generated from field: int64 tip_refunded_cents = 43;
   */
  tipRefundedCents: bigint;

  /**
   * @generated from field: int64 tip_disputed_cents = 44;
   */
  tipDisputedCents: bigint;
};

/**
 * Describes the message cortado.v1.PaymentSchedule.
 * Use `create(PaymentScheduleSchema)` to create a new message.
 */
export const PaymentScheduleSchema: GenMessage<PaymentSchedule> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 12);

/**
 * PaymentScheduleLite is a lightweight payment schedule for dashboard views.
 * Includes enriched contact and invoice info for display without additional queries.
 *
 * @generated from message cortado.v1.PaymentScheduleLite
 */
export type PaymentScheduleLite = Message<"cortado.v1.PaymentScheduleLite"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string invoice_id = 3;
   */
  invoiceId: string;

  /**
   * @generated from field: int32 sequence_number = 4;
   */
  sequenceNumber: number;

  /**
   * @generated from field: string description = 5;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 6;
   */
  dueDate?: Timestamp;

  /**
   * @generated from field: int64 amount_cents = 7;
   */
  amountCents: bigint;

  /**
   * @generated from field: int64 amount_paid_cents = 8;
   */
  amountPaidCents: bigint;

  /**
   * @generated from field: cortado.v1.PaymentScheduleStatusEnum status = 9;
   */
  status: PaymentScheduleStatusEnum;

  /**
   * Enriched fields for dashboard display
   *
   * @generated from field: string contact_id = 10;
   */
  contactId: string;

  /**
   * Full name (e.g., "John Smith")
   *
   * @generated from field: string contact_name = 11;
   */
  contactName: string;

  /**
   * Invoice title for context
   *
   * @generated from field: string invoice_title = 12;
   */
  invoiceTitle: string;

  /**
   * Invoice number for display
   *
   * @generated from field: int32 invoice_number = 13;
   */
  invoiceNumber: number;
};

/**
 * Describes the message cortado.v1.PaymentScheduleLite.
 * Use `create(PaymentScheduleLiteSchema)` to create a new message.
 */
export const PaymentScheduleLiteSchema: GenMessage<PaymentScheduleLite> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 13);

/**
 * QuotePaymentSchedule represents a scheduled payment for a quote - configuration for payment installments on quotes
 *
 * @generated from message cortado.v1.QuotePaymentSchedule
 */
export type QuotePaymentSchedule = Message<"cortado.v1.QuotePaymentSchedule"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string quote_id = 3;
   */
  quoteId: string;

  /**
   * @generated from field: string quote_revision_id = 4;
   */
  quoteRevisionId: string;

  /**
   * @generated from field: int32 sequence_number = 5;
   */
  sequenceNumber: number;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 7;
   */
  dueDate?: Timestamp;

  /**
   * Amount configuration - either percentage or fixed amount
   *
   * @generated from field: cortado.v1.QuotePaymentScheduleAmountTypeEnum amount_type = 8;
   */
  amountType: QuotePaymentScheduleAmountTypeEnum;

  /**
   * e.g., 50.0 for 50%
   *
   * @generated from field: optional double percentage = 9;
   */
  percentage?: number;

  /**
   * Fixed amount in cents
   *
   * @generated from field: optional int64 amount_cents = 10;
   */
  amountCents?: bigint;

  /**
   * Calculated amount for display (computed from percentage × total or from fixed amount)
   *
   * @generated from field: optional int64 calculated_amount_cents = 11;
   */
  calculatedAmountCents?: bigint;

  /**
   * Tip-on-last logic: indicates this is the last schedule in the sequence (tip added here)
   *
   * @generated from field: bool is_last_schedule = 12;
   */
  isLastSchedule: boolean;

  /**
   * Base plus this schedule's share of the enforced tip; set on every schedule with a share > 0
   *
   * @generated from field: optional int64 amount_with_tip_cents = 13;
   */
  amountWithTipCents?: bigint;

  /**
   * How due_date is interpreted. UNSPECIFIED is treated as ABSOLUTE.
   * AFTER_ACCEPTANCE / BEFORE_EVENT use due_offset_days; due_date is a preview.
   *
   * @generated from field: cortado.v1.QuotePaymentScheduleDueDateAnchorEnum due_date_anchor = 14;
   */
  dueDateAnchor: QuotePaymentScheduleDueDateAnchorEnum;

  /**
   * @generated from field: int32 due_offset_days = 15;
   */
  dueOffsetDays: number;

  /**
   * Timestamps
   *
   * @generated from field: google.protobuf.Timestamp created_at = 20;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 21;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.QuotePaymentSchedule.
 * Use `create(QuotePaymentScheduleSchema)` to create a new message.
 */
export const QuotePaymentScheduleSchema: GenMessage<QuotePaymentSchedule> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 14);

/**
 * QuotePaymentScheduleInput represents input data for creating/updating quote payment schedules
 *
 * @generated from message cortado.v1.QuotePaymentScheduleInput
 */
export type QuotePaymentScheduleInput = Message<"cortado.v1.QuotePaymentScheduleInput"> & {
  /**
   * @generated from field: int32 sequence_number = 1;
   */
  sequenceNumber: number;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: google.protobuf.Timestamp due_date = 3;
   */
  dueDate?: Timestamp;

  /**
   * Exactly one of percentage or amount_cents must be set based on amount_type
   *
   * @generated from field: cortado.v1.QuotePaymentScheduleAmountTypeEnum amount_type = 4;
   */
  amountType: QuotePaymentScheduleAmountTypeEnum;

  /**
   * @generated from field: optional double percentage = 5;
   */
  percentage?: number;

  /**
   * @generated from field: optional int64 amount_cents = 6;
   */
  amountCents?: bigint;

  /**
   * How due_date is interpreted. UNSPECIFIED is treated as ABSOLUTE.
   *
   * @generated from field: cortado.v1.QuotePaymentScheduleDueDateAnchorEnum due_date_anchor = 7;
   */
  dueDateAnchor: QuotePaymentScheduleDueDateAnchorEnum;

  /**
   * @generated from field: int32 due_offset_days = 8;
   */
  dueOffsetDays: number;
};

/**
 * Describes the message cortado.v1.QuotePaymentScheduleInput.
 * Use `create(QuotePaymentScheduleInputSchema)` to create a new message.
 */
export const QuotePaymentScheduleInputSchema: GenMessage<QuotePaymentScheduleInput> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 15);

/**
 * PaymentIntent represents a Stripe payment intent
 *
 * @generated from message cortado.v1.PaymentIntent
 */
export type PaymentIntent = Message<"cortado.v1.PaymentIntent"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string invoice_id = 3;
   */
  invoiceId: string;

  /**
   * @generated from field: string payment_schedule_id = 4;
   */
  paymentScheduleId: string;

  /**
   * @generated from field: string stripe_payment_intent_id = 5;
   */
  stripePaymentIntentId: string;

  /**
   * @generated from field: int64 amount_cents = 6;
   */
  amountCents: bigint;

  /**
   * @generated from field: cortado.v1.PaymentIntentStatusEnum status = 7;
   */
  status: PaymentIntentStatusEnum;

  /**
   * @generated from field: string client_secret = 8;
   */
  clientSecret: string;

  /**
   * Payment method details
   *
   * @generated from field: optional string payment_method_id = 10;
   */
  paymentMethodId?: string;

  /**
   * @generated from field: optional string payment_method_type = 11;
   */
  paymentMethodType?: string;

  /**
   * @generated from field: optional string payment_method_last4 = 12;
   */
  paymentMethodLast4?: string;

  /**
   * @generated from field: optional string payment_method_brand = 13;
   */
  paymentMethodBrand?: string;

  /**
   * Status timestamps
   *
   * @generated from field: optional google.protobuf.Timestamp paid_at = 20;
   */
  paidAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp failed_at = 21;
   */
  failedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp canceled_at = 22;
   */
  canceledAt?: Timestamp;

  /**
   * Failure details
   *
   * @generated from field: optional string failure_message = 30;
   */
  failureMessage?: string;

  /**
   * @generated from field: optional string failure_code = 31;
   */
  failureCode?: string;

  /**
   * Financial details
   *
   * @generated from field: optional int64 stripe_fee_cents = 40;
   */
  stripeFeeCents?: bigint;

  /**
   * @generated from field: optional int64 net_amount_cents = 41;
   */
  netAmountCents?: bigint;

  /**
   * Raw Stripe data
   *
   * @generated from field: optional string metadata_json = 50;
   */
  metadataJson?: string;

  /**
   * Timestamps
   *
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 61;
   */
  updatedAt?: Timestamp;

  /**
   * Nested payments (Stripe Charges) for this payment intent
   *
   * @generated from field: repeated cortado.v1.StripePayment payments = 70;
   */
  payments: StripePayment[];
};

/**
 * Describes the message cortado.v1.PaymentIntent.
 * Use `create(PaymentIntentSchema)` to create a new message.
 */
export const PaymentIntentSchema: GenMessage<PaymentIntent> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 16);

/**
 * StripePayment represents an individual Stripe Charge (payment attempt)
 * A single PaymentIntent can have multiple charges (e.g., failed card attempt + successful retry)
 *
 * @generated from message cortado.v1.StripePayment
 */
export type StripePayment = Message<"cortado.v1.StripePayment"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Replaced payment_intent_id
   *
   * @generated from field: optional string checkout_session_id = 3;
   */
  checkoutSessionId?: string;

  /**
   * @generated from field: string stripe_charge_id = 4;
   */
  stripeChargeId: string;

  /**
   * @generated from field: string stripe_payment_intent_id = 5;
   */
  stripePaymentIntentId: string;

  /**
   * Core charge data
   *
   * @generated from field: int64 amount_cents = 10;
   */
  amountCents: bigint;

  /**
   * @generated from field: cortado.v1.StripePaymentStatusEnum status = 11;
   */
  status: StripePaymentStatusEnum;

  /**
   * @generated from field: bool paid = 12;
   */
  paid: boolean;

  /**
   * Outcome details (from Stripe charge.outcome)
   *
   * @generated from field: optional cortado.v1.PaymentOutcomeTypeEnum outcome_type = 20;
   */
  outcomeType?: PaymentOutcomeTypeEnum;

  /**
   * @generated from field: optional cortado.v1.PaymentNetworkStatusEnum outcome_network_status = 21;
   */
  outcomeNetworkStatus?: PaymentNetworkStatusEnum;

  /**
   * @generated from field: optional string outcome_reason = 22;
   */
  outcomeReason?: string;

  /**
   * @generated from field: optional cortado.v1.PaymentRiskLevelEnum outcome_risk_level = 23;
   */
  outcomeRiskLevel?: PaymentRiskLevelEnum;

  /**
   * @generated from field: optional int32 outcome_risk_score = 24;
   */
  outcomeRiskScore?: number;

  /**
   * @generated from field: optional string outcome_seller_message = 25;
   */
  outcomeSellerMessage?: string;

  /**
   * Failure details
   *
   * @generated from field: optional string failure_code = 30;
   */
  failureCode?: string;

  /**
   * @generated from field: optional string failure_message = 31;
   */
  failureMessage?: string;

  /**
   * Payment method details
   *
   * @generated from field: optional string payment_method_id = 40;
   */
  paymentMethodId?: string;

  /**
   * @generated from field: optional string payment_method_type = 41;
   */
  paymentMethodType?: string;

  /**
   * @generated from field: optional string payment_method_last4 = 42;
   */
  paymentMethodLast4?: string;

  /**
   * @generated from field: optional string payment_method_brand = 43;
   */
  paymentMethodBrand?: string;

  /**
   * @generated from field: optional string payment_method_wallet_type = 44;
   */
  paymentMethodWalletType?: string;

  /**
   * Card verification checks
   *
   * @generated from field: optional cortado.v1.CardCheckResultEnum cvc_check = 50;
   */
  cvcCheck?: CardCheckResultEnum;

  /**
   * @generated from field: optional cortado.v1.CardCheckResultEnum address_line1_check = 51;
   */
  addressLine1Check?: CardCheckResultEnum;

  /**
   * @generated from field: optional cortado.v1.CardCheckResultEnum address_postal_code_check = 52;
   */
  addressPostalCodeCheck?: CardCheckResultEnum;

  /**
   * Refund tracking
   *
   * @generated from field: bool refunded = 60;
   */
  refunded: boolean;

  /**
   * @generated from field: int64 amount_refunded_cents = 61;
   */
  amountRefundedCents: bigint;

  /**
   * Financial reconciliation
   *
   * @generated from field: optional string balance_transaction_id = 70;
   */
  balanceTransactionId?: string;

  /**
   * Timestamps
   *
   * @generated from field: optional google.protobuf.Timestamp stripe_created_at = 80;
   */
  stripeCreatedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 81;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 82;
   */
  updatedAt?: Timestamp;

  /**
   * Currency (ISO 4217 code, e.g., "USD", "EUR")
   *
   * @generated from field: string currency = 85;
   */
  currency: string;

  /**
   * Extended refund tracking (for admin-initiated refunds)
   *
   * @generated from field: optional string refund_reason = 90;
   */
  refundReason?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp refunded_at = 91;
   */
  refundedAt?: Timestamp;

  /**
   * @generated from field: optional string refunded_by = 92;
   */
  refundedBy?: string;

  /**
   * Fee tracking (from balance transaction)
   *
   * @generated from field: optional int64 stripe_fee_cents = 95;
   */
  stripeFeeCents?: bigint;

  /**
   * @generated from field: optional int64 application_fee_cents = 96;
   */
  applicationFeeCents?: bigint;

  /**
   * @generated from field: optional int64 net_amount_cents = 97;
   */
  netAmountCents?: bigint;
};

/**
 * Describes the message cortado.v1.StripePayment.
 * Use `create(StripePaymentSchema)` to create a new message.
 */
export const StripePaymentSchema: GenMessage<StripePayment> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 17);

/**
 * ManualPayment represents a payment recorded outside of Stripe (check, wire transfer, cash, ACH)
 *
 * @generated from message cortado.v1.ManualPayment
 */
export type ManualPayment = Message<"cortado.v1.ManualPayment"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string invoice_id = 3;
   */
  invoiceId: string;

  /**
   * @generated from field: optional string payment_schedule_id = 4;
   */
  paymentScheduleId?: string;

  /**
   * Payment details
   *
   * @generated from field: int64 amount_cents = 10;
   */
  amountCents: bigint;

  /**
   * @generated from field: cortado.v1.ManualPaymentMethodEnum payment_method = 11;
   */
  paymentMethod: ManualPaymentMethodEnum;

  /**
   * @generated from field: google.protobuf.Timestamp payment_date = 12;
   */
  paymentDate?: Timestamp;

  /**
   * @generated from field: optional string reference_number = 13;
   */
  referenceNumber?: string;

  /**
   * @generated from field: optional string notes = 14;
   */
  notes?: string;

  /**
   * ISO 4217 code (e.g., "USD")
   *
   * @generated from field: string currency = 15;
   */
  currency: string;

  /**
   * Voiding (for admin corrections)
   *
   * @generated from field: bool voided = 20;
   */
  voided: boolean;

  /**
   * @generated from field: optional google.protobuf.Timestamp voided_at = 21;
   */
  voidedAt?: Timestamp;

  /**
   * @generated from field: optional string voided_by = 22;
   */
  voidedBy?: string;

  /**
   * @generated from field: optional string void_reason = 23;
   */
  voidReason?: string;

  /**
   * Recording info
   *
   * @generated from field: string recorded_by = 30;
   */
  recordedBy: string;

  /**
   * Timestamps
   *
   * @generated from field: google.protobuf.Timestamp created_at = 40;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 41;
   */
  updatedAt?: Timestamp;

  /**
   * Enrichment
   *
   * @generated from field: optional cortado.v1.User recorded_by_user = 50;
   */
  recordedByUser?: User;

  /**
   * @generated from field: optional cortado.v1.User voided_by_user = 51;
   */
  voidedByUser?: User;
};

/**
 * Describes the message cortado.v1.ManualPayment.
 * Use `create(ManualPaymentSchema)` to create a new message.
 */
export const ManualPaymentSchema: GenMessage<ManualPayment> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 18);

/**
 * Item represents a catalog item
 *
 * @generated from message cortado.v1.Item
 */
export type Item = Message<"cortado.v1.Item"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: optional string description = 4;
   */
  description?: string;

  /**
   * @generated from field: float price = 5;
   */
  price: number;

  /**
   * @generated from field: optional cortado.v1.ItemUnitEnum unit = 6;
   */
  unit?: ItemUnitEnum;

  /**
   * @generated from field: bool always_include = 7;
   */
  alwaysInclude: boolean;

  /**
   * @generated from field: bool include_on_form = 8;
   */
  includeOnForm: boolean;

  /**
   * @generated from field: int32 form_display_order = 13;
   */
  formDisplayOrder: number;

  /**
   * @generated from field: bool offer_as_addon = 14;
   */
  offerAsAddon: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 10;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 12;
   */
  updatedBy: string;

  /**
   * Embedded objects
   *
   * @generated from field: optional cortado.v1.User created_by_user = 20;
   */
  createdByUser?: User;

  /**
   * @generated from field: optional cortado.v1.User updated_by_user = 21;
   */
  updatedByUser?: User;

  /**
   * @generated from field: cortado.v1.ItemKindEnum item_kind = 22;
   */
  itemKind: ItemKindEnum;

  /**
   * @generated from field: double mileage_threshold_miles = 23;
   */
  mileageThresholdMiles: number;

  /**
   * Gallery images for this item, ordered by sort_order. The cover image has
   * is_primary = true. Populated on list/get/create/update responses.
   *
   * @generated from field: repeated cortado.v1.ItemImage images = 24;
   */
  images: ItemImage[];
};

/**
 * Describes the message cortado.v1.Item.
 * Use `create(ItemSchema)` to create a new message.
 */
export const ItemSchema: GenMessage<Item> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 19);

/**
 * LineItemImage is the customer-facing view of one catalog item image, shown
 * beside a quote or invoice line item in the portal.
 *
 * @generated from message cortado.v1.LineItemImage
 */
export type LineItemImage = Message<"cortado.v1.LineItemImage"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: string alt_text = 2;
   */
  altText: string;

  /**
   * @generated from field: optional int32 width_px = 3;
   */
  widthPx?: number;

  /**
   * @generated from field: optional int32 height_px = 4;
   */
  heightPx?: number;
};

/**
 * Describes the message cortado.v1.LineItemImage.
 * Use `create(LineItemImageSchema)` to create a new message.
 */
export const LineItemImageSchema: GenMessage<LineItemImage> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 20);

/**
 * ItemImage is one gallery image on a catalog item. Images are served from a
 * public bucket, so public_url is stable and safe to embed in the customer
 * portal, emails, and PDFs.
 *
 * @generated from message cortado.v1.ItemImage
 */
export type ItemImage = Message<"cortado.v1.ItemImage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string item_id = 3;
   */
  itemId: string;

  /**
   * @generated from field: string public_url = 20;
   */
  publicUrl: string;

  /**
   * @generated from field: string filename = 21;
   */
  filename: string;

  /**
   * @generated from field: string content_type = 22;
   */
  contentType: string;

  /**
   * @generated from field: int64 size_bytes = 23;
   */
  sizeBytes: bigint;

  /**
   * @generated from field: optional int32 width_px = 24;
   */
  widthPx?: number;

  /**
   * @generated from field: optional int32 height_px = 25;
   */
  heightPx?: number;

  /**
   * @generated from field: string alt_text = 26;
   */
  altText: string;

  /**
   * @generated from field: int32 sort_order = 27;
   */
  sortOrder: number;

  /**
   * @generated from field: bool is_primary = 50;
   */
  isPrimary: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 61;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 62;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 63;
   */
  updatedBy: string;
};

/**
 * Describes the message cortado.v1.ItemImage.
 * Use `create(ItemImageSchema)` to create a new message.
 */
export const ItemImageSchema: GenMessage<ItemImage> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 21);

/**
 * TaxRate represents a tax rate/sales tax in the system
 *
 * @generated from message cortado.v1.TaxRate
 */
export type TaxRate = Message<"cortado.v1.TaxRate"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string tax_type = 3;
   */
  taxType: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: float percentage = 5;
   */
  percentage: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 7;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 9;
   */
  updatedBy: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp archived_at = 10;
   */
  archivedAt?: Timestamp;

  /**
   * Embedded objects
   *
   * @generated from field: optional cortado.v1.User created_by_user = 20;
   */
  createdByUser?: User;

  /**
   * @generated from field: optional cortado.v1.User updated_by_user = 21;
   */
  updatedByUser?: User;
};

/**
 * Describes the message cortado.v1.TaxRate.
 * Use `create(TaxRateSchema)` to create a new message.
 */
export const TaxRateSchema: GenMessage<TaxRate> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 22);

/**
 * Discount represents a discount in the system
 *
 * @generated from message cortado.v1.Discount
 */
export type Discount = Message<"cortado.v1.Discount"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: optional string description = 4;
   */
  description?: string;

  /**
   * @generated from field: cortado.v1.DiscountTypeEnum discount_type = 5;
   */
  discountType: DiscountTypeEnum;

  /**
   * @generated from field: float value = 6;
   */
  value: number;

  /**
   * @generated from field: optional bool is_active = 7;
   */
  isActive?: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 9;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional string updated_by = 11;
   */
  updatedBy?: string;

  /**
   * Embedded objects
   *
   * @generated from field: optional cortado.v1.User created_by_user = 20;
   */
  createdByUser?: User;

  /**
   * @generated from field: optional cortado.v1.User updated_by_user = 21;
   */
  updatedByUser?: User;
};

/**
 * Describes the message cortado.v1.Discount.
 * Use `create(DiscountSchema)` to create a new message.
 */
export const DiscountSchema: GenMessage<Discount> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 23);

/**
 * @generated from message cortado.v1.QuoteTemplateItem
 */
export type QuoteTemplateItem = Message<"cortado.v1.QuoteTemplateItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string template_id = 2;
   */
  templateId: string;

  /**
   * @generated from field: string item_id = 3;
   */
  itemId: string;

  /**
   * @generated from field: cortado.v1.QuoteTemplateItemScalingType scaling_type = 4;
   */
  scalingType: QuoteTemplateItemScalingType;

  /**
   * @generated from field: int64 rate_cents = 5;
   */
  rateCents: bigint;

  /**
   * @generated from field: int32 sort_order = 6;
   */
  sortOrder: number;

  /**
   * @generated from field: optional cortado.v1.Item item = 7;
   */
  item?: Item;
};

/**
 * Describes the message cortado.v1.QuoteTemplateItem.
 * Use `create(QuoteTemplateItemSchema)` to create a new message.
 */
export const QuoteTemplateItemSchema: GenMessage<QuoteTemplateItem> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 24);

/**
 * QuoteTemplate represents event-type-specific pricing configuration
 *
 * @generated from message cortado.v1.QuoteTemplate
 */
export type QuoteTemplate = Message<"cortado.v1.QuoteTemplate"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: optional cortado.v1.EventTypeEnum event_type = 3 [deprecated = true];
   * @deprecated
   */
  eventType?: EventTypeEnum;

  /**
   * Deprecated: Use template_items instead. Legacy fixed 2-slot references.
   *
   * @generated from field: optional string base_item_id = 4;
   */
  baseItemId?: string;

  /**
   * Deprecated: Use template_items instead. Legacy fixed 2-slot references.
   *
   * @generated from field: optional string hourly_item_id = 5;
   */
  hourlyItemId?: string;

  /**
   * @generated from field: int32 minimum_hours = 6;
   */
  minimumHours: number;

  /**
   * @generated from field: bool is_active = 7;
   */
  isActive: boolean;

  /**
   * Deprecated: Use template_items with per-item rate_cents instead.
   *
   * @generated from field: int64 base_item_rate_cents = 12;
   */
  baseItemRateCents: bigint;

  /**
   * Deprecated: Use template_items with per-item rate_cents instead.
   *
   * @generated from field: int64 hourly_item_rate_cents = 13;
   */
  hourlyItemRateCents: bigint;

  /**
   * @generated from field: string title = 14;
   */
  title: string;

  /**
   * @generated from field: optional string quote_title = 15;
   */
  quoteTitle?: string;

  /**
   * @generated from field: optional string quote_description = 16;
   */
  quoteDescription?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 9;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 11;
   */
  updatedBy: string;

  /**
   * Embedded objects
   *
   * @generated from field: optional cortado.v1.User created_by_user = 20;
   */
  createdByUser?: User;

  /**
   * @generated from field: optional cortado.v1.User updated_by_user = 21;
   */
  updatedByUser?: User;

  /**
   * @generated from field: optional string event_type_key = 25;
   */
  eventTypeKey?: string;

  /**
   * Deprecated: Use template_items instead. Legacy fixed 2-slot references.
   *
   * @generated from field: optional cortado.v1.Item base_item = 22;
   */
  baseItem?: Item;

  /**
   * Deprecated: Use template_items instead. Legacy fixed 2-slot references.
   *
   * @generated from field: optional cortado.v1.Item hourly_item = 23;
   */
  hourlyItem?: Item;

  /**
   * @generated from field: repeated cortado.v1.QuoteTemplateItem template_items = 24;
   */
  templateItems: QuoteTemplateItem[];
};

/**
 * Describes the message cortado.v1.QuoteTemplate.
 * Use `create(QuoteTemplateSchema)` to create a new message.
 */
export const QuoteTemplateSchema: GenMessage<QuoteTemplate> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 25);

/**
 * Payment represents a payment for an invoice (DEPRECATED - use PaymentIntent)
 *
 * @generated from message cortado.v1.Payment
 */
export type Payment = Message<"cortado.v1.Payment"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string payment_schedule_item_id = 2;
   */
  paymentScheduleItemId?: string;

  /**
   * @generated from field: float amount_paid = 3;
   */
  amountPaid: number;

  /**
   * @generated from field: optional string payment_method_id = 4;
   */
  paymentMethodId?: string;

  /**
   * @generated from field: optional string payment_method_type = 5;
   */
  paymentMethodType?: string;

  /**
   * @generated from field: optional string payment_intent_id = 6;
   */
  paymentIntentId?: string;

  /**
   * @generated from field: optional string charge_id = 7;
   */
  chargeId?: string;

  /**
   * @generated from field: cortado.v1.PaymentStatusEnum payment_status = 9;
   */
  paymentStatus: PaymentStatusEnum;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.Payment.
 * Use `create(PaymentSchema)` to create a new message.
 */
export const PaymentSchema: GenMessage<Payment> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 26);

/**
 * QuoteItem is the old name for QuoteLineItem (DEPRECATED - use QuoteLineItem)
 *
 * @generated from message cortado.v1.QuoteItem
 */
export type QuoteItem = Message<"cortado.v1.QuoteItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string quote_id = 2;
   */
  quoteId: string;

  /**
   * @generated from field: string item_id = 3;
   */
  itemId: string;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: optional string description = 5;
   */
  description?: string;

  /**
   * @generated from field: int32 quantity = 6;
   */
  quantity: number;

  /**
   * @generated from field: float unit_price = 7;
   */
  unitPrice: number;

  /**
   * @generated from field: optional cortado.v1.ItemUnitEnum unit = 8;
   */
  unit?: ItemUnitEnum;

  /**
   * @generated from field: int32 ordering = 9;
   */
  ordering: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 11;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 13;
   */
  updatedBy: string;

  /**
   * Embedded item details
   *
   * @generated from field: optional cortado.v1.Item item = 20;
   */
  item?: Item;

  /**
   * Pre-calculated
   *
   * @generated from field: float line_total = 30;
   */
  lineTotal: number;
};

/**
 * Describes the message cortado.v1.QuoteItem.
 * Use `create(QuoteItemSchema)` to create a new message.
 */
export const QuoteItemSchema: GenMessage<QuoteItem> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 27);

/**
 * InvoiceItem is the old name for InvoiceLineItem (DEPRECATED - use InvoiceLineItem)
 *
 * @generated from message cortado.v1.InvoiceItem
 */
export type InvoiceItem = Message<"cortado.v1.InvoiceItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string invoice_id = 2;
   */
  invoiceId: string;

  /**
   * @generated from field: string item_id = 3;
   */
  itemId: string;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: optional string description = 5;
   */
  description?: string;

  /**
   * @generated from field: int32 quantity = 6;
   */
  quantity: number;

  /**
   * @generated from field: float unit_price = 7;
   */
  unitPrice: number;

  /**
   * @generated from field: optional cortado.v1.ItemUnitEnum unit = 8;
   */
  unit?: ItemUnitEnum;

  /**
   * @generated from field: int32 ordering = 9;
   */
  ordering: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 11;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string updated_by = 13;
   */
  updatedBy: string;

  /**
   * @generated from field: optional cortado.v1.Item item = 20;
   */
  item?: Item;

  /**
   * @generated from field: float line_total = 30;
   */
  lineTotal: number;
};

/**
 * Describes the message cortado.v1.InvoiceItem.
 * Use `create(InvoiceItemSchema)` to create a new message.
 */
export const InvoiceItemSchema: GenMessage<InvoiceItem> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 28);

/**
 * CreateQuoteItemInput is used when creating a quote to specify item details
 *
 * @generated from message cortado.v1.CreateQuoteItemInput
 */
export type CreateQuoteItemInput = Message<"cortado.v1.CreateQuoteItemInput"> & {
  /**
   * @generated from field: string item_id = 1;
   */
  itemId: string;

  /**
   * @generated from field: int32 quantity = 2;
   */
  quantity: number;

  /**
   * @generated from field: optional float unit_price_override = 3;
   */
  unitPriceOverride?: number;

  /**
   * @generated from field: optional string title_override = 4;
   */
  titleOverride?: string;

  /**
   * @generated from field: optional string description_override = 5;
   */
  descriptionOverride?: string;
};

/**
 * Describes the message cortado.v1.CreateQuoteItemInput.
 * Use `create(CreateQuoteItemInputSchema)` to create a new message.
 */
export const CreateQuoteItemInputSchema: GenMessage<CreateQuoteItemInput> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 29);

/**
 * RecordManualPaymentRequest is used to record a payment made outside of Stripe
 *
 * @generated from message cortado.v1.RecordManualPaymentRequest
 */
export type RecordManualPaymentRequest = Message<"cortado.v1.RecordManualPaymentRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * @generated from field: string payment_schedule_id = 2;
   */
  paymentScheduleId: string;

  /**
   * @generated from field: int64 amount_cents = 3;
   */
  amountCents: bigint;

  /**
   * @generated from field: cortado.v1.ManualPaymentMethodEnum payment_method = 4;
   */
  paymentMethod: ManualPaymentMethodEnum;

  /**
   * @generated from field: google.protobuf.Timestamp payment_date = 5;
   */
  paymentDate?: Timestamp;

  /**
   * @generated from field: optional string reference_number = 6;
   */
  referenceNumber?: string;

  /**
   * @generated from field: optional string notes = 7;
   */
  notes?: string;

  /**
   * Send receipt email to customer
   *
   * @generated from field: bool send_receipt_email = 8;
   */
  sendReceiptEmail: boolean;

  /**
   * Client-generated idempotency key (e.g. a UUID minted per form entry).
   * Resubmissions of the same logical payment must reuse the same key; distinct
   * payments must use distinct keys. When absent, the server falls back to a
   * key derived from (invoice, schedule, amount, method, payment_date), which
   * cannot distinguish two legitimate same-day/same-amount payments.
   *
   * @generated from field: optional string idempotency_key = 9;
   */
  idempotencyKey?: string;
};

/**
 * Describes the message cortado.v1.RecordManualPaymentRequest.
 * Use `create(RecordManualPaymentRequestSchema)` to create a new message.
 */
export const RecordManualPaymentRequestSchema: GenMessage<RecordManualPaymentRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 30);

/**
 * RecordManualPaymentResponse contains the created payment and updated invoice
 *
 * @generated from message cortado.v1.RecordManualPaymentResponse
 */
export type RecordManualPaymentResponse = Message<"cortado.v1.RecordManualPaymentResponse"> & {
  /**
   * @generated from field: cortado.v1.ManualPayment payment = 1;
   */
  payment?: ManualPayment;

  /**
   * @generated from field: cortado.v1.Invoice invoice = 2;
   */
  invoice?: Invoice;
};

/**
 * Describes the message cortado.v1.RecordManualPaymentResponse.
 * Use `create(RecordManualPaymentResponseSchema)` to create a new message.
 */
export const RecordManualPaymentResponseSchema: GenMessage<RecordManualPaymentResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 31);

/**
 * BatchManualPaymentEntry represents a single payment entry for batch recording
 *
 * @generated from message cortado.v1.BatchManualPaymentEntry
 */
export type BatchManualPaymentEntry = Message<"cortado.v1.BatchManualPaymentEntry"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * optional - if not provided, will use first unpaid schedule
   *
   * @generated from field: optional string payment_schedule_id = 2;
   */
  paymentScheduleId?: string;

  /**
   * @generated from field: int64 amount_cents = 3;
   */
  amountCents: bigint;

  /**
   * @generated from field: cortado.v1.ManualPaymentMethodEnum payment_method = 4;
   */
  paymentMethod: ManualPaymentMethodEnum;

  /**
   * @generated from field: google.protobuf.Timestamp payment_date = 5;
   */
  paymentDate?: Timestamp;

  /**
   * @generated from field: optional string reference_number = 6;
   */
  referenceNumber?: string;

  /**
   * @generated from field: optional string notes = 7;
   */
  notes?: string;

  /**
   * Client-generated idempotency key (see RecordManualPaymentRequest.idempotency_key).
   *
   * @generated from field: optional string idempotency_key = 8;
   */
  idempotencyKey?: string;
};

/**
 * Describes the message cortado.v1.BatchManualPaymentEntry.
 * Use `create(BatchManualPaymentEntrySchema)` to create a new message.
 */
export const BatchManualPaymentEntrySchema: GenMessage<BatchManualPaymentEntry> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 32);

/**
 * RecordBatchManualPaymentsRequest records multiple manual payments atomically
 *
 * @generated from message cortado.v1.RecordBatchManualPaymentsRequest
 */
export type RecordBatchManualPaymentsRequest = Message<"cortado.v1.RecordBatchManualPaymentsRequest"> & {
  /**
   * @generated from field: repeated cortado.v1.BatchManualPaymentEntry payments = 1;
   */
  payments: BatchManualPaymentEntry[];

  /**
   * Send receipt emails for all payments
   *
   * @generated from field: bool send_receipt_emails = 2;
   */
  sendReceiptEmails: boolean;
};

/**
 * Describes the message cortado.v1.RecordBatchManualPaymentsRequest.
 * Use `create(RecordBatchManualPaymentsRequestSchema)` to create a new message.
 */
export const RecordBatchManualPaymentsRequestSchema: GenMessage<RecordBatchManualPaymentsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 33);

/**
 * RecordBatchManualPaymentsResponse contains all recorded payments
 *
 * @generated from message cortado.v1.RecordBatchManualPaymentsResponse
 */
export type RecordBatchManualPaymentsResponse = Message<"cortado.v1.RecordBatchManualPaymentsResponse"> & {
  /**
   * All recorded payments
   *
   * @generated from field: repeated cortado.v1.ManualPayment payments = 1;
   */
  payments: ManualPayment[];

  /**
   * Number of payments successfully recorded
   *
   * @generated from field: int32 success_count = 2;
   */
  successCount: number;
};

/**
 * Describes the message cortado.v1.RecordBatchManualPaymentsResponse.
 * Use `create(RecordBatchManualPaymentsResponseSchema)` to create a new message.
 */
export const RecordBatchManualPaymentsResponseSchema: GenMessage<RecordBatchManualPaymentsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 34);

/**
 * ProcessStripeRefundRequest is used to initiate a refund through Stripe
 *
 * @generated from message cortado.v1.ProcessStripeRefundRequest
 */
export type ProcessStripeRefundRequest = Message<"cortado.v1.ProcessStripeRefundRequest"> & {
  /**
   * @generated from field: string payment_id = 1;
   */
  paymentId: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents: bigint;

  /**
   * @generated from field: optional string reason = 3;
   */
  reason?: string;

  /**
   * true = goodwill refund (reduces invoice total), false = customer will repay
   *
   * @generated from field: bool is_goodwill = 4;
   */
  isGoodwill: boolean;
};

/**
 * Describes the message cortado.v1.ProcessStripeRefundRequest.
 * Use `create(ProcessStripeRefundRequestSchema)` to create a new message.
 */
export const ProcessStripeRefundRequestSchema: GenMessage<ProcessStripeRefundRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 35);

/**
 * ProcessStripeRefundResponse contains the updated payment and invoice
 *
 * @generated from message cortado.v1.ProcessStripeRefundResponse
 */
export type ProcessStripeRefundResponse = Message<"cortado.v1.ProcessStripeRefundResponse"> & {
  /**
   * @generated from field: cortado.v1.StripePayment payment = 1;
   */
  payment?: StripePayment;

  /**
   * @generated from field: cortado.v1.Invoice invoice = 2;
   */
  invoice?: Invoice;

  /**
   * @generated from field: string stripe_refund_id = 3;
   */
  stripeRefundId: string;

  /**
   * The created refund record
   *
   * @generated from field: cortado.v1.InvoiceRefund refund = 4;
   */
  refund?: InvoiceRefund;
};

/**
 * Describes the message cortado.v1.ProcessStripeRefundResponse.
 * Use `create(ProcessStripeRefundResponseSchema)` to create a new message.
 */
export const ProcessStripeRefundResponseSchema: GenMessage<ProcessStripeRefundResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 36);

/**
 * InvoiceRefund represents a refund record for an invoice
 *
 * @generated from message cortado.v1.InvoiceRefund
 */
export type InvoiceRefund = Message<"cortado.v1.InvoiceRefund"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string invoice_id = 3;
   */
  invoiceId: string;

  /**
   * @generated from field: string payment_id = 4;
   */
  paymentId: string;

  /**
   * @generated from field: optional string payment_schedule_id = 5;
   */
  paymentScheduleId?: string;

  /**
   * @generated from field: int64 amount_cents = 10;
   */
  amountCents: bigint;

  /**
   * @generated from field: bool is_goodwill = 11;
   */
  isGoodwill: boolean;

  /**
   * @generated from field: optional string reason = 12;
   */
  reason?: string;

  /**
   * @generated from field: optional string stripe_refund_id = 13;
   */
  stripeRefundId?: string;

  /**
   * ISO 4217 code (e.g., "USD")
   *
   * @generated from field: string currency = 14;
   */
  currency: string;

  /**
   * @generated from field: optional string refunded_by = 20;
   */
  refundedBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp refunded_at = 21;
   */
  refundedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 22;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.InvoiceRefund.
 * Use `create(InvoiceRefundSchema)` to create a new message.
 */
export const InvoiceRefundSchema: GenMessage<InvoiceRefund> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 37);

/**
 * VoidManualPaymentRequest is used to void a manual payment (admin correction)
 *
 * @generated from message cortado.v1.VoidManualPaymentRequest
 */
export type VoidManualPaymentRequest = Message<"cortado.v1.VoidManualPaymentRequest"> & {
  /**
   * @generated from field: string payment_id = 1;
   */
  paymentId: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * Send void notification email to customer
   *
   * @generated from field: bool send_void_notification = 3;
   */
  sendVoidNotification: boolean;
};

/**
 * Describes the message cortado.v1.VoidManualPaymentRequest.
 * Use `create(VoidManualPaymentRequestSchema)` to create a new message.
 */
export const VoidManualPaymentRequestSchema: GenMessage<VoidManualPaymentRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 38);

/**
 * VoidManualPaymentResponse contains the voided payment and updated invoice
 *
 * @generated from message cortado.v1.VoidManualPaymentResponse
 */
export type VoidManualPaymentResponse = Message<"cortado.v1.VoidManualPaymentResponse"> & {
  /**
   * @generated from field: cortado.v1.ManualPayment payment = 1;
   */
  payment?: ManualPayment;

  /**
   * @generated from field: cortado.v1.Invoice invoice = 2;
   */
  invoice?: Invoice;
};

/**
 * Describes the message cortado.v1.VoidManualPaymentResponse.
 * Use `create(VoidManualPaymentResponseSchema)` to create a new message.
 */
export const VoidManualPaymentResponseSchema: GenMessage<VoidManualPaymentResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 39);

/**
 * ListInvoicePaymentsRequest is used to list all payments for an invoice
 *
 * @generated from message cortado.v1.ListInvoicePaymentsRequest
 */
export type ListInvoicePaymentsRequest = Message<"cortado.v1.ListInvoicePaymentsRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * @generated from field: optional int32 page_size = 2;
   */
  pageSize?: number;

  /**
   * @generated from field: optional string page_token = 3;
   */
  pageToken?: string;

  /**
   * Date range filter
   *
   * @generated from field: optional google.protobuf.Timestamp date_from = 10;
   */
  dateFrom?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp date_to = 11;
   */
  dateTo?: Timestamp;

  /**
   * Amount range filter (in cents)
   *
   * @generated from field: optional int64 amount_min_cents = 12;
   */
  amountMinCents?: bigint;

  /**
   * @generated from field: optional int64 amount_max_cents = 13;
   */
  amountMaxCents?: bigint;

  /**
   * Payment source filter (stripe vs manual)
   *
   * @generated from field: optional bool stripe_only = 14;
   */
  stripeOnly?: boolean;

  /**
   * @generated from field: optional bool manual_only = 15;
   */
  manualOnly?: boolean;

  /**
   * For manual payments: method filter
   *
   * @generated from field: repeated cortado.v1.ManualPaymentMethodEnum manual_methods = 16;
   */
  manualMethods: ManualPaymentMethodEnum[];

  /**
   * Text search for reference numbers (manual payments only)
   *
   * @generated from field: optional string reference_search = 17;
   */
  referenceSearch?: string;

  /**
   * Include voided manual payments (default: false)
   *
   * @generated from field: optional bool include_voided = 18;
   */
  includeVoided?: boolean;
};

/**
 * Describes the message cortado.v1.ListInvoicePaymentsRequest.
 * Use `create(ListInvoicePaymentsRequestSchema)` to create a new message.
 */
export const ListInvoicePaymentsRequestSchema: GenMessage<ListInvoicePaymentsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 40);

/**
 * ListInvoicePaymentsResponse contains both Stripe and manual payments
 *
 * @generated from message cortado.v1.ListInvoicePaymentsResponse
 */
export type ListInvoicePaymentsResponse = Message<"cortado.v1.ListInvoicePaymentsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.StripePayment stripe_payments = 1;
   */
  stripePayments: StripePayment[];

  /**
   * @generated from field: repeated cortado.v1.ManualPayment manual_payments = 2;
   */
  manualPayments: ManualPayment[];

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListInvoicePaymentsResponse.
 * Use `create(ListInvoicePaymentsResponseSchema)` to create a new message.
 */
export const ListInvoicePaymentsResponseSchema: GenMessage<ListInvoicePaymentsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 41);

/**
 * ExportInvoicePaymentsRequest exports payments for an invoice as CSV
 * Uses the same filter options as ListInvoicePaymentsRequest
 *
 * @generated from message cortado.v1.ExportInvoicePaymentsRequest
 */
export type ExportInvoicePaymentsRequest = Message<"cortado.v1.ExportInvoicePaymentsRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * Date range filter
   *
   * @generated from field: optional google.protobuf.Timestamp date_from = 10;
   */
  dateFrom?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp date_to = 11;
   */
  dateTo?: Timestamp;

  /**
   * Amount range filter (in cents)
   *
   * @generated from field: optional int64 amount_min_cents = 12;
   */
  amountMinCents?: bigint;

  /**
   * @generated from field: optional int64 amount_max_cents = 13;
   */
  amountMaxCents?: bigint;

  /**
   * Payment source filter (stripe vs manual)
   *
   * @generated from field: optional bool stripe_only = 14;
   */
  stripeOnly?: boolean;

  /**
   * @generated from field: optional bool manual_only = 15;
   */
  manualOnly?: boolean;

  /**
   * For manual payments: method filter
   *
   * @generated from field: repeated cortado.v1.ManualPaymentMethodEnum manual_methods = 16;
   */
  manualMethods: ManualPaymentMethodEnum[];

  /**
   * Text search for reference numbers (manual payments only)
   *
   * @generated from field: optional string reference_search = 17;
   */
  referenceSearch?: string;

  /**
   * Include voided manual payments (default: false)
   *
   * @generated from field: optional bool include_voided = 18;
   */
  includeVoided?: boolean;
};

/**
 * Describes the message cortado.v1.ExportInvoicePaymentsRequest.
 * Use `create(ExportInvoicePaymentsRequestSchema)` to create a new message.
 */
export const ExportInvoicePaymentsRequestSchema: GenMessage<ExportInvoicePaymentsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 42);

/**
 * ExportInvoicePaymentsResponse contains the CSV data
 *
 * @generated from message cortado.v1.ExportInvoicePaymentsResponse
 */
export type ExportInvoicePaymentsResponse = Message<"cortado.v1.ExportInvoicePaymentsResponse"> & {
  /**
   * CSV file content
   *
   * @generated from field: bytes csv_data = 1;
   */
  csvData: Uint8Array;

  /**
   * Suggested filename for download
   *
   * @generated from field: string filename = 2;
   */
  filename: string;

  /**
   * Number of payment rows exported
   *
   * @generated from field: int32 row_count = 3;
   */
  rowCount: number;
};

/**
 * Describes the message cortado.v1.ExportInvoicePaymentsResponse.
 * Use `create(ExportInvoicePaymentsResponseSchema)` to create a new message.
 */
export const ExportInvoicePaymentsResponseSchema: GenMessage<ExportInvoicePaymentsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 43);

/**
 * VoidInvoiceRequest is used to cancel an invoice
 *
 * @generated from message cortado.v1.VoidInvoiceRequest
 */
export type VoidInvoiceRequest = Message<"cortado.v1.VoidInvoiceRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * Optional reason for voiding
   *
   * @generated from field: optional string reason = 2;
   */
  reason?: string;

  /**
   * When false and payments exist, returns FAILED_PRECONDITION with details. When true, proceeds with void.
   *
   * @generated from field: bool force = 3;
   */
  force: boolean;
};

/**
 * Describes the message cortado.v1.VoidInvoiceRequest.
 * Use `create(VoidInvoiceRequestSchema)` to create a new message.
 */
export const VoidInvoiceRequestSchema: GenMessage<VoidInvoiceRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 44);

/**
 * VoidInvoiceResponse contains the voided invoice
 *
 * @generated from message cortado.v1.VoidInvoiceResponse
 */
export type VoidInvoiceResponse = Message<"cortado.v1.VoidInvoiceResponse"> & {
  /**
   * @generated from field: cortado.v1.Invoice invoice = 1;
   */
  invoice?: Invoice;
};

/**
 * Describes the message cortado.v1.VoidInvoiceResponse.
 * Use `create(VoidInvoiceResponseSchema)` to create a new message.
 */
export const VoidInvoiceResponseSchema: GenMessage<VoidInvoiceResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 45);

/**
 * MarkInvoiceAsPaidRequest marks an invoice as fully paid by creating a manual payment
 *
 * @generated from message cortado.v1.MarkInvoiceAsPaidRequest
 */
export type MarkInvoiceAsPaidRequest = Message<"cortado.v1.MarkInvoiceAsPaidRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * Method of payment (cash, check, wire, other)
   *
   * @generated from field: cortado.v1.ManualPaymentMethodEnum payment_method = 2;
   */
  paymentMethod: ManualPaymentMethodEnum;

  /**
   * Optional reference (check number, wire ID, etc.)
   *
   * @generated from field: optional string reference_number = 3;
   */
  referenceNumber?: string;

  /**
   * Optional notes about the payment
   *
   * @generated from field: optional string notes = 4;
   */
  notes?: string;
};

/**
 * Describes the message cortado.v1.MarkInvoiceAsPaidRequest.
 * Use `create(MarkInvoiceAsPaidRequestSchema)` to create a new message.
 */
export const MarkInvoiceAsPaidRequestSchema: GenMessage<MarkInvoiceAsPaidRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 46);

/**
 * MarkInvoiceAsPaidResponse contains the created payment(s) and updated invoice
 *
 * @generated from message cortado.v1.MarkInvoiceAsPaidResponse
 */
export type MarkInvoiceAsPaidResponse = Message<"cortado.v1.MarkInvoiceAsPaidResponse"> & {
  /**
   * @generated from field: cortado.v1.ManualPayment payment = 1;
   */
  payment?: ManualPayment;

  /**
   * @generated from field: cortado.v1.Invoice invoice = 2;
   */
  invoice?: Invoice;

  /**
   * @generated from field: repeated cortado.v1.ManualPayment payments = 3;
   */
  payments: ManualPayment[];
};

/**
 * Describes the message cortado.v1.MarkInvoiceAsPaidResponse.
 * Use `create(MarkInvoiceAsPaidResponseSchema)` to create a new message.
 */
export const MarkInvoiceAsPaidResponseSchema: GenMessage<MarkInvoiceAsPaidResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 47);

/**
 * SendInvoiceRequest sends an invoice email to the customer
 * For DRAFT invoices, updates status to SENT. For already-sent invoices, resends the email.
 *
 * @generated from message cortado.v1.SendInvoiceRequest
 */
export type SendInvoiceRequest = Message<"cortado.v1.SendInvoiceRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * Client-generated UUID for this logical send operation. Reuse it when
   * retrying an ambiguous request; generate a new UUID for an intentional resend.
   *
   * @generated from field: optional string idempotency_key = 2;
   */
  idempotencyKey?: string;
};

/**
 * Describes the message cortado.v1.SendInvoiceRequest.
 * Use `create(SendInvoiceRequestSchema)` to create a new message.
 */
export const SendInvoiceRequestSchema: GenMessage<SendInvoiceRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 48);

/**
 * SendInvoiceResponse returns the updated invoice after sending
 *
 * @generated from message cortado.v1.SendInvoiceResponse
 */
export type SendInvoiceResponse = Message<"cortado.v1.SendInvoiceResponse"> & {
  /**
   * @generated from field: cortado.v1.Invoice invoice = 1;
   */
  invoice?: Invoice;
};

/**
 * Describes the message cortado.v1.SendInvoiceResponse.
 * Use `create(SendInvoiceResponseSchema)` to create a new message.
 */
export const SendInvoiceResponseSchema: GenMessage<SendInvoiceResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 49);

/**
 * SendPaymentReminderRequest sends a payment reminder email for an invoice
 *
 * @generated from message cortado.v1.SendPaymentReminderRequest
 */
export type SendPaymentReminderRequest = Message<"cortado.v1.SendPaymentReminderRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * Optional custom message to include in the email
   *
   * @generated from field: optional string custom_message = 2;
   */
  customMessage?: string;
};

/**
 * Describes the message cortado.v1.SendPaymentReminderRequest.
 * Use `create(SendPaymentReminderRequestSchema)` to create a new message.
 */
export const SendPaymentReminderRequestSchema: GenMessage<SendPaymentReminderRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 50);

/**
 * SendPaymentReminderResponse contains info about the sent reminder
 *
 * @generated from message cortado.v1.SendPaymentReminderResponse
 */
export type SendPaymentReminderResponse = Message<"cortado.v1.SendPaymentReminderResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * e.g., "Reminder sent to customer@example.com"
   *
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.SendPaymentReminderResponse.
 * Use `create(SendPaymentReminderResponseSchema)` to create a new message.
 */
export const SendPaymentReminderResponseSchema: GenMessage<SendPaymentReminderResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 51);

/**
 * GenerateInvoicePortalLinkRequest is used to generate a shareable portal link for an invoice
 * The link allows customers to view and pay the invoice without logging in
 *
 * @generated from message cortado.v1.GenerateInvoicePortalLinkRequest
 */
export type GenerateInvoicePortalLinkRequest = Message<"cortado.v1.GenerateInvoicePortalLinkRequest"> & {
  /**
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * Retained for compatibility; new links use a fixed 30-day lifetime
   *
   * @generated from field: optional int64 expires_in_hours = 2 [deprecated = true];
   * @deprecated
   */
  expiresInHours?: bigint;

  /**
   * Legacy: true maps to anonymous; false maps to recipient
   *
   * @generated from field: bool omit_token = 3 [deprecated = true];
   * @deprecated
   */
  omitToken: boolean;

  /**
   * @generated from field: optional cortado.v1.PortalAttributionModeEnum attribution_mode = 4;
   */
  attributionMode?: PortalAttributionModeEnum;
};

/**
 * Describes the message cortado.v1.GenerateInvoicePortalLinkRequest.
 * Use `create(GenerateInvoicePortalLinkRequestSchema)` to create a new message.
 */
export const GenerateInvoicePortalLinkRequestSchema: GenMessage<GenerateInvoicePortalLinkRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 52);

/**
 * GenerateInvoicePortalLinkResponse contains the generated portal link
 *
 * @generated from message cortado.v1.GenerateInvoicePortalLinkResponse
 */
export type GenerateInvoicePortalLinkResponse = Message<"cortado.v1.GenerateInvoicePortalLinkResponse"> & {
  /**
   * Full portal URL; short alias when enabled, legacy token query otherwise
   *
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * JWT retained for wire compatibility; never embedded in short URLs
   *
   * @generated from field: string token = 2 [deprecated = true];
   * @deprecated
   */
  token: string;

  /**
   * When the token or short alias expires (30 days after issuance)
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 3;
   */
  expiresAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.GenerateInvoicePortalLinkResponse.
 * Use `create(GenerateInvoicePortalLinkResponseSchema)` to create a new message.
 */
export const GenerateInvoicePortalLinkResponseSchema: GenMessage<GenerateInvoicePortalLinkResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 53);

/**
 * Dispute represents a Stripe dispute (chargeback) for a payment
 *
 * @generated from message cortado.v1.Dispute
 */
export type Dispute = Message<"cortado.v1.Dispute"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string stripe_charge_id = 3;
   */
  stripeChargeId: string;

  /**
   * Stripe dispute ID (dp_xxx)
   *
   * @generated from field: string dispute_id = 4;
   */
  disputeId: string;

  /**
   * @generated from field: cortado.v1.DisputeStatusEnum status = 5;
   */
  status: DisputeStatusEnum;

  /**
   * Dispute reason (e.g., "fraudulent", "product_not_received")
   *
   * @generated from field: string reason = 6;
   */
  reason: string;

  /**
   * Disputed amount in cents
   *
   * @generated from field: int64 amount_cents = 7;
   */
  amountCents: bigint;

  /**
   * Original payment amount for context
   *
   * @generated from field: int64 original_payment_cents = 8;
   */
  originalPaymentCents: bigint;

  /**
   * Timestamps
   *
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp closed_at = 11;
   */
  closedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp evidence_due_by = 12;
   */
  evidenceDueBy?: Timestamp;

  /**
   * Related entities (for linking to invoice/payment)
   *
   * @generated from field: optional string checkout_session_id = 20;
   */
  checkoutSessionId?: string;

  /**
   * @generated from field: optional string invoice_id = 21;
   */
  invoiceId?: string;

  /**
   * Denormalized contact info for display
   *
   * @generated from field: optional string contact_name = 30;
   */
  contactName?: string;

  /**
   * Payment method details for display
   *
   * @generated from field: optional string payment_method_brand = 40;
   */
  paymentMethodBrand?: string;

  /**
   * @generated from field: optional string payment_method_last4 = 41;
   */
  paymentMethodLast4?: string;
};

/**
 * Describes the message cortado.v1.Dispute.
 * Use `create(DisputeSchema)` to create a new message.
 */
export const DisputeSchema: GenMessage<Dispute> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 54);

/**
 * ListDisputesRequest is used to list disputes for an organization
 *
 * @generated from message cortado.v1.ListDisputesRequest
 */
export type ListDisputesRequest = Message<"cortado.v1.ListDisputesRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Optional filter by dispute statuses
   *
   * @generated from field: repeated cortado.v1.DisputeStatusEnum statuses = 2;
   */
  statuses: DisputeStatusEnum[];

  /**
   * Optional flag to include closed disputes (WON, LOST, WARNING_CLOSED, CHARGE_REFUNDED)
   *
   * @generated from field: optional bool include_closed = 3;
   */
  includeClosed?: boolean;

  /**
   * Pagination
   *
   * @generated from field: optional int32 limit = 10;
   */
  limit?: number;

  /**
   * @generated from field: optional int32 offset = 11;
   */
  offset?: number;
};

/**
 * Describes the message cortado.v1.ListDisputesRequest.
 * Use `create(ListDisputesRequestSchema)` to create a new message.
 */
export const ListDisputesRequestSchema: GenMessage<ListDisputesRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 55);

/**
 * ListDisputesResponse contains disputes and summary counts
 *
 * @generated from message cortado.v1.ListDisputesResponse
 */
export type ListDisputesResponse = Message<"cortado.v1.ListDisputesResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.Dispute disputes = 1;
   */
  disputes: Dispute[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * Count of disputes requiring immediate action
   *
   * @generated from field: int32 needs_response_count = 3;
   */
  needsResponseCount: number;
};

/**
 * Describes the message cortado.v1.ListDisputesResponse.
 * Use `create(ListDisputesResponseSchema)` to create a new message.
 */
export const ListDisputesResponseSchema: GenMessage<ListDisputesResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_invoices, 56);

/**
 * @generated from enum cortado.v1.QuoteTemplateItemScalingType
 */
export enum QuoteTemplateItemScalingType {
  /**
   * @generated from enum value: QUOTE_TEMPLATE_ITEM_SCALING_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: QUOTE_TEMPLATE_ITEM_SCALING_TYPE_FIXED = 1;
   */
  FIXED = 1,

  /**
   * @generated from enum value: QUOTE_TEMPLATE_ITEM_SCALING_TYPE_PER_OVERAGE_HOUR = 2;
   */
  PER_OVERAGE_HOUR = 2,

  /**
   * @generated from enum value: QUOTE_TEMPLATE_ITEM_SCALING_TYPE_PER_BARISTA_PER_HOUR = 3;
   */
  PER_BARISTA_PER_HOUR = 3,

  /**
   * @generated from enum value: QUOTE_TEMPLATE_ITEM_SCALING_TYPE_PER_CART = 4;
   */
  PER_CART = 4,
}

/**
 * Describes the enum cortado.v1.QuoteTemplateItemScalingType.
 */
export const QuoteTemplateItemScalingTypeSchema: GenEnum<QuoteTemplateItemScalingType> = /*@__PURE__*/
  enumDesc(file_cortado_v1_invoices, 0);

